// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Wrk","question":"styles_question__Mp0r2","description":"styles_description__1be9a"};